import React from "react";
import { connect } from "react-redux";
import { getDealFiles, addFileToDeal, deleteDealFile, clearNewDealId } from 'store/state/deal';
import AttachmentsDrawer from 'components/Global/Attachments/AttachmentsDrawer';
import _ from 'lodash';

class DealAttachments extends React.Component {

  componentDidUpdate(prevProps, prevState){
    const { dealId,isOpen} = this.props;
    const {isOpen: prevIsOpen} = prevProps;
    if(isOpen !== prevIsOpen && isOpen){
      this.props.getDealFiles({
        modelName: 'deal',
        modelId:dealId,
        subKey: dealId
      })
    }
  }

  handleRemoveFile = (fileId) => {
    const {dealId} = this.props;
    this.props.deleteDealFile({
      fileId: fileId, 
      shouldUpdateAfter:true, 
      modelName: 'deal',
      modelId: dealId,
      subKey:dealId });
  }

  render() {
    const {isOpen, closeAttachments, dealFiles, dealId, addFileToDeal, isLoading} = this.props;    
    const specificDealFiles = dealFiles[dealId] || [];

    return (
      <React.Fragment>
        <AttachmentsDrawer
          internalID = {"ForDeal"+dealId}
          addFile={(file) => addFileToDeal('deal', dealId, file, '/files')}
          isOpen={isOpen}
          isLoading={isLoading}
          closeDrawer={closeAttachments}
          files={specificDealFiles} 
          handleRemove={this.handleRemoveFile}/>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ deal, loading}) => ({
  dealFiles: deal.dealFiles,
  isLoading: loading.deal_file_upload
});

export default connect(
  mapStateToProps,
  {   
    getDealFiles,
    addFileToDeal,
    deleteDealFile
  }
)(DealAttachments);

